/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as giftCardActions from './GiftCard-Actions';
import * as giftCardOperations from './GiftCard-Operations';

const giftCardWatcherSagas = [
    ...giftCardOperations.watchers,
];

export {
    giftCardOperations,
    giftCardActions,
    giftCardWatcherSagas,
};
